var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlocked = function SvgBlocked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6966A4",
    fillRule: "evenodd",
    d: "M16.833 9.001a8.333 8.333 0 1 1-16.666 0 8.333 8.333 0 0 1 16.666 0m-5.208 0c0 .345-.28.625-.625.625H6a.625.625 0 1 1 0-1.25h5c.345 0 .625.28.625.625",
    clipRule: "evenodd"
  })));
};
export default SvgBlocked;